import {ErrorFabricService} from 'app/core/error-handler/error-fabric.service';
import {ErrorNotifierService} from 'app/core/error-handler/error-notifier.service';
import {Observable, Subscription} from 'rxjs';
import {PartialObserver} from 'rxjs';

export function safeSubscribersFactory(errorNotifier: ErrorNotifierService, errorFactory: ErrorFabricService) {
    const safeErrorHandler = error => {
        const internalError = errorFactory.create(error);
        errorNotifier.handleError(internalError);
        errorNotifier.notifyUser(internalError);
    };

    return () => {
        const originalDescriptor = Object.getOwnPropertyDescriptor(Observable.prototype, 'subscribe');
        Object.defineProperty(Observable.prototype, 'subscribe', {
            ...originalDescriptor,
            value(...args: Array<Function | PartialObserver<any>>) {
                if (typeof args[0] === 'function') {
                    // in that case 3 functions is supposed to be taken
                    // onNext, onError and onComplete
                    // we want to patch just on error if it is not passed
                    const patchedArgs = [...args];
                    if (!patchedArgs[1]) {
                        patchedArgs[1] = safeErrorHandler;
                    }
                    return originalDescriptor.value.apply(this, patchedArgs);
                } else {
                    let observer = args[0] as PartialObserver<any>;
                    // to prevent patching internal RxJS subscriptions
                    if (!(observer instanceof Subscription)) {
                        observer = {...observer};
                        observer.error = observer.error || safeErrorHandler;
                    }
                    return originalDescriptor.value.call(this, observer);
                }
            },
        });

        return Promise.resolve();
    };
}
